import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import authModule, { IAuthModuleState } from '@/store/modules/auth'
import appModule, { IAppModuleState } from '@/store/modules/app'
import alertModule, { IAlertModuleState } from '@/store/modules/alert'

Vue.use(Vuex)

export interface IStoreRootState {
    appModule: IAppModuleState,
    authModule: IAuthModuleState,
    alertModule: IAlertModuleState
}

const store: StoreOptions<IStoreRootState> = {
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        appModule,
        authModule,
        alertModule
    }
}

export default new Vuex.Store<IStoreRootState>(store)
